exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50}.is-hidden{display:none}h1,h2{font-weight:400}ul{list-style-type:none;padding:0}li{display:inline-block;margin:0 10px}a{color:#42b983}body{margin:0;background-color:#fcfff5}.nav-bar{padding:1em;background-color:#193441;color:#fff}.container{display:flex;flex-wrap:wrap}.card{flex-grow:1;background-color:#91aa9d;padding:1.5em;margin:1em}.location{margin-bottom:20px;background-color:#fff;text-align:center;padding:20px}.active{color:green}.inactive{color:red}.text-bold{font-weight:700}.viz{padding-bottom:40px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43184481","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 334
// module chunks = 0